import { DrEntity } from './dr-entity';
import { TagState } from './enums';

export enum TaggedGroup {
    NONE = 'NONE',
    ON = 'ON',
    NOT = 'NOT',
    PARTIAL = 'PARTIAL'
}

export class TaggedEntity extends DrEntity {
    name: string;
    displayValue: string;
    tagState: TagState;
    taggedGroup: TaggedGroup;

    constructor(value?: Partial<TaggedEntity>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}
